import React from 'react'

import { CalenderInput } from '../reusables/FormElements'

interface IReportDatePickerProps {
  required: boolean;
  startDate: string;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  endDate: string;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
}

const ReportDatePicker = (props: IReportDatePickerProps) => {
  const { startDate, setStartDate, endDate, setEndDate, required } = props;

  return (
    <div className='immersion__date_picker'>
      <p className='immersion__date_picker__label'>Date</p>
      <CalenderInput
        name="start_date"
        label=""
        required={required}
        errorMsg={""}
        placeholder="mm/dd/yyyy"
        format="mm/dd/yyyy"
        onChange={(value: string) => setStartDate(value)}
        value={startDate}
        read_only={false}
      />
      <CalenderInput
        name="end_date"
        label=""
        required={required}
        errorMsg={""}
        placeholder="mm/dd/yyyy"
        format="mm/dd/yyyy"
        onChange={(value: string) => setEndDate(value)}
        value={endDate}
        read_only={false}
      />
    </div>
  )
}

export default ReportDatePicker